import { useContext } from 'react';
import {
  AuthContext,
  ActionCreator as AuthActionCreator,
} from '../../context/AuthProvider';

export const useAuthContext = () => {
  const {
    authDispatch,
    authState: {
      userId,
      isUserSubscribed,
      freePremiumGenerationsAttemptsCount,
      authStatus,
      isInitialUserDataUpdated,
      clientHash,
    },
  } = useContext(AuthContext);

  return {
    authDispatch,
    userId,
    isUserLogged: !!userId,
    isUserSubscribed,
    freePremiumGenerationsAttemptsCount,
    authStatus,
    AuthActionCreator,
    isInitialUserDataUpdated,
    clientHash,
  };
};
